<template lang="pug">
  .asset-list(:class="{ base: isBase, quote: !isBase }")
    ul
      li.asset(
        v-for="asset in assets"
        :class="{ selected: isSelected(asset, isBase), blocked: isBlocked(asset) }"
        @click="tryUpdateAsset(asset)"
      )
        img(:src="asset.image || genericAssetImage")
        span.code {{asset.code}}
</template>

<script>
  import genericAssetImage from '@/assets/logo.png'
  import { mapState, mapMutations } from 'vuex'

  export default {
    props: {
      isBase: {
        type: Boolean,
        required: true
      },
      assets: {
        type: Array,
        required: true
      },
      selectedAsset: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        genericAssetImage
      }
    },
    computed: {
      ...mapState(['baseAsset', 'quoteAsset'])
    },
    methods: {
      ...mapMutations(['setBaseAsset', 'setQuoteAsset']),
      tryUpdateAsset (asset) {
        if (!this.isBlocked(asset)) {
          if (this.isBase) this.setBaseAsset(asset)
          else this.setQuoteAsset(asset)
        }
      },
      isBlocked (asset) {
        return this.isSelected(asset, !this.isBase)
      },
      isSelected (asset, checkForBase) {
        if (checkForBase) {
          return asset.code === this.baseAsset.code && asset.issuer === this.baseAsset.issuer
        } else {
          return asset.code === this.quoteAsset.code && asset.issuer === this.quoteAsset.issuer
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/variables.sass"
  @import "@/assets/styles/mixins/scrollbar.sass"

  .asset-list
    display: flex
    overflow-y: auto
    overflow-x: hidden

    +scrollbar

    &.base
      align-items: flex-end

      li
        border-top: $border

    &.quote li
      border-bottom: $border

  ul
    margin: 0
    padding: 0
    width: 100%
    max-height: 100%

    li
      display: flex
      align-items: center

      padding: 0.6em

      font-weight: lighter
      font-size: 1.25rem

      background-color: white

      cursor: pointer

      &.selected
        color: $color
        font-weight: normal
        border-left: 3px solid $color

      &.blocked
        img, .code
          opacity: 0.5

      &:hover:not(.blocked)
        background-color: darken(white, 3%) // stylelint-disable-line csstree/validator

  .asset
    img
      height: 1.75rem
      margin-right: 0.5rem

    img, .code
      display: block
</style>
